// Service Categories Configuration - 2-Level Cascading System
// Level 1: Métier / Domaine
// Level 2: Prestation (depends on Level 1)

export const DOMAINS = [
  { value: "commun", label: "Commun à tous les métiers" },
  { value: "multiservices", label: "Multiservices & Petits travaux" },
  { value: "plomberie", label: "Plomberie" },
  { value: "electricite", label: "Électricité" },
  { value: "chauffage_clim", label: "Chauffage, Climatisation & Ventilation" },
  { value: "maconnerie", label: "Maçonnerie & Gros œuvre" },
  { value: "carrelage", label: "Carrelage & Revêtements" },
  { value: "peinture", label: "Peinture & Décoration" },
  { value: "plaquiste", label: "Plaquiste & Isolation" },
  { value: "facade", label: "Façade & Ravalement" },
  { value: "menuiserie", label: "Menuiserie & Charpente" },
  { value: "couverture", label: "Couverture & Zinguerie" },
  { value: "serrurerie", label: "Serrurerie & Métallerie" },
  { value: "vitrerie", label: "Vitrerie & Miroiterie" },
  { value: "cuisine_sdb", label: "Cuisine & Salle de bain" },
  { value: "terrassement", label: "Terrassement & VRD" },
  { value: "jardinage", label: "Jardinage & Espaces verts" },
  { value: "nettoyage", label: "Entretien & Nettoyage" },
  { value: "aide_personne", label: "Garde & Aide à la personne" },
  { value: "animaux", label: "Garde & Soins animaux" },
  { value: "informatique", label: "Informatique & High-tech" },
  { value: "demenagement", label: "Déménagement & Transport" },
  { value: "administratif", label: "Administratif & Services" },
  { value: "autre", label: "Autre (saisie libre)", isCustom: true }
];

export const PRESTATIONS = {
  commun: [
    { value: "main_oeuvre", label: "Main d'œuvre" },
    { value: "forfait_intervention", label: "Forfait intervention" },
    { value: "forfait_journee", label: "Forfait journée" },
    { value: "forfait_demi_journee", label: "Forfait demi-journée" },
    { value: "diagnostic_visite", label: "Diagnostic / visite technique" },
    { value: "deplacement_transport", label: "Déplacement & Transport" },
    { value: "frais_deplacement_km", label: "Frais de déplacement (km)" },
    { value: "frais_stationnement", label: "Frais stationnement / péage" },
    { value: "fournitures_materiaux", label: "Fournitures & Matériaux" },
    { value: "location_materiel", label: "Location matériel" },
    { value: "depose_demontage", label: "Dépose / démontage" },
    { value: "evacuation_dechets", label: "Évacuation des déchets" },
    { value: "nettoyage_fin_chantier", label: "Nettoyage fin de chantier" },
    { value: "protection_chantier", label: "Protection chantier" },
    { value: "mise_en_service", label: "Mise en service" },
    { value: "sous_traitance", label: "Sous-traitance" },
    { value: "etudes_plans", label: "Études & Plans" },
    { value: "garantie_sav", label: "Garantie & SAV" },
    { value: "urgence_astreinte", label: "Urgence & Astreinte" },
    { value: "majoration_weekend", label: "Majoration weekend / férié" },
    { value: "majoration_nuit", label: "Majoration nuit" },
    { value: "divers", label: "Divers" },
    { value: "commun_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  multiservices: [
    { value: "petits_travaux", label: "Petits travaux divers" },
    { value: "montage_meuble", label: "Montage meuble" },
    { value: "fixation_murale", label: "Fixation murale / pose support" },
    { value: "pose_tringle", label: "Pose tringle / store / rideau" },
    { value: "reparation_diverse", label: "Réparation diverse" },
    { value: "remplacement_joint", label: "Remplacement joint / silicone" },
    { value: "petite_plomberie", label: "Petite plomberie" },
    { value: "petite_electricite", label: "Petite électricité" },
    { value: "retouches_peinture", label: "Retouches peinture" },
    { value: "multiservices_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  plomberie: [
    { value: "installation_sanitaire", label: "Installation sanitaire" },
    { value: "depannage_plomberie", label: "Dépannage plomberie" },
    { value: "recherche_fuite", label: "Recherche & réparation fuite" },
    { value: "remplacement_robinetterie", label: "Remplacement robinetterie" },
    { value: "installation_baignoire", label: "Installation baignoire" },
    { value: "installation_douche", label: "Installation douche / receveur" },
    { value: "installation_wc", label: "Installation WC / toilettes" },
    { value: "installation_lavabo", label: "Installation lavabo / évier" },
    { value: "pose_evier", label: "Pose évier" },
    { value: "pose_meuble_vasque", label: "Pose meuble vasque" },
    { value: "remplacement_siphon", label: "Remplacement siphon / bonde" },
    { value: "debouchage_canalisation", label: "Débouchage canalisation" },
    { value: "remplacement_canalisation", label: "Remplacement canalisation" },
    { value: "remplacement_chauffe_eau", label: "Remplacement chauffe-eau" },
    { value: "chauffe_eau_thermodynamique", label: "Chauffe-eau thermodynamique" },
    { value: "remplacement_groupe_securite", label: "Remplacement groupe de sécurité" },
    { value: "raccordement_electromenager", label: "Raccordement électroménager" },
    { value: "detartrage", label: "Détartrage installation" },
    { value: "desembouage", label: "Désembouage chauffage" },
    { value: "adoucisseur_eau", label: "Adoucisseur d'eau" },
    { value: "fosse_septique", label: "Fosse septique / assainissement" },
    { value: "fournitures_sanitaires", label: "Fournitures sanitaires" },
    { value: "plomberie_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  electricite: [
    { value: "cablage_installation", label: "Câblage & Installation électrique" },
    { value: "renovation_electrique", label: "Rénovation installation électrique" },
    { value: "tableau_electrique", label: "Tableau électrique" },
    { value: "mise_aux_normes", label: "Mise aux normes électriques" },
    { value: "creation_ligne", label: "Création ligne électrique" },
    { value: "installation_prise", label: "Installation prise électrique" },
    { value: "prise_rj45", label: "Installation prise RJ45" },
    { value: "installation_interrupteur", label: "Installation interrupteur" },
    { value: "mise_terre", label: "Mise à la terre" },
    { value: "installation_luminaire", label: "Installation luminaire / plafonnier" },
    { value: "eclairage_led", label: "Éclairage LED" },
    { value: "eclairage_spot", label: "Pose spots encastrés" },
    { value: "eclairage_exterieur", label: "Éclairage extérieur" },
    { value: "installation_tableau", label: "Remplacement tableau électrique" },
    { value: "disjoncteur", label: "Remplacement disjoncteur" },
    { value: "borne_recharge", label: "Borne de recharge véhicule" },
    { value: "domotique_alarme", label: "Domotique & Alarme" },
    { value: "installation_alarme", label: "Installation alarme" },
    { value: "detecteur_fumee", label: "Pose détecteur de fumée" },
    { value: "videosurveillance", label: "Vidéosurveillance" },
    { value: "interphone_visiophone", label: "Interphone / Visiophone" },
    { value: "motorisation_portail", label: "Motorisation portail" },
    { value: "installation_wifi", label: "Installation réseau / WiFi" },
    { value: "installation_tv_antenne", label: "Installation antenne / TV" },
    { value: "installation_fibre", label: "Passage fibre optique" },
    { value: "installation_chauffe_eau_elec", label: "Installation chauffe-eau électrique" },
    { value: "depannage_electrique", label: "Dépannage électrique" },
    { value: "depannage_coupure", label: "Dépannage coupure / court-circuit" },
    { value: "diagnostic_electrique", label: "Diagnostic électrique" },
    { value: "electricite_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  chauffage_clim: [
    { value: "installation_chaudiere", label: "Installation chaudière" },
    { value: "entretien_chaudiere_clim", label: "Entretien / révision chaudière" },
    { value: "remplacement_chaudiere", label: "Remplacement chaudière" },
    { value: "installation_pac", label: "Installation pompe à chaleur" },
    { value: "entretien_pac", label: "Entretien pompe à chaleur" },
    { value: "installation_radiateur", label: "Installation radiateur" },
    { value: "remplacement_radiateur", label: "Remplacement radiateur" },
    { value: "plancher_chauffant", label: "Plancher chauffant" },
    { value: "installation_clim", label: "Installation climatisation" },
    { value: "entretien_clim", label: "Entretien climatisation" },
    { value: "installation_vmc_clim", label: "Installation VMC" },
    { value: "entretien_vmc_clim", label: "Entretien VMC" },
    { value: "chauffage_clim_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  maconnerie: [
    { value: "gros_oeuvre", label: "Gros œuvre" },
    { value: "construction_mur", label: "Construction mur / cloison" },
    { value: "demolition_mur", label: "Démolition mur / cloison" },
    { value: "ouverture_mur_porteur", label: "Ouverture mur porteur" },
    { value: "demolition", label: "Démolition & Dépose" },
    { value: "terrassement_fondations", label: "Terrassement & Fondations" },
    { value: "beton_dallage", label: "Béton & Dallage" },
    { value: "dalle_beton", label: "Coulage dalle béton" },
    { value: "chape", label: "Coulage chape" },
    { value: "ragréage_sol", label: "Ragréage sol" },
    { value: "pose_brique", label: "Pose brique / parpaing" },
    { value: "enduits_crepis", label: "Enduits & Crépis" },
    { value: "enduit_interieur", label: "Enduit intérieur" },
    { value: "isolation_exterieure", label: "Isolation thermique extérieure (ITE)" },
    { value: "isolation_interieure", label: "Isolation thermique intérieure" },
    { value: "reprise_fissures", label: "Reprise fissures" },
    { value: "mur_soutenement", label: "Mur de soutènement" },
    { value: "pose_paves", label: "Pose pavés / dallage" },
    { value: "escalier_beton", label: "Escalier béton" },
    { value: "fondation_cloture", label: "Fondations clôture" },
    { value: "construction_terrasse", label: "Construction terrasse" },
    { value: "cloture_portail", label: "Clôture & Portail" },
    { value: "maconnerie_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  carrelage: [
    { value: "pose_carrelage_sol", label: "Pose carrelage sol" },
    { value: "pose_faience", label: "Pose faïence murale" },
    { value: "reprise_joints", label: "Reprise joints" },
    { value: "depose_carrelage", label: "Dépose carrelage" },
    { value: "ragrage", label: "Ragréage" },
    { value: "pose_dalle_pvc", label: "Pose dalle PVC / vinyle" },
    { value: "pose_revetement_sol", label: "Pose revêtement de sol" },
    { value: "carrelage_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  peinture: [
    { value: "peinture_interieure", label: "Peinture intérieure" },
    { value: "peinture_plafond", label: "Peinture plafond" },
    { value: "peinture_murs", label: "Peinture murs" },
    { value: "peinture_boiseries", label: "Peinture boiseries / volets" },
    { value: "peinture_exterieure", label: "Peinture extérieure" },
    { value: "peinture_portail", label: "Peinture portail / ferronnerie" },
    { value: "papier_peint", label: "Papier peint & Revêtement mural" },
    { value: "pose_toile_de_verre", label: "Pose toile de verre" },
    { value: "preparation_supports", label: "Préparation des supports" },
    { value: "lessivage", label: "Lessivage" },
    { value: "decapage", label: "Décapage" },
    { value: "rebouchage_lissage", label: "Rebouchage & Lissage" },
    { value: "poncage", label: "Ponçage" },
    { value: "sous_couche", label: "Sous-couche / impression" },
    { value: "lasure_vernis", label: "Lasure / vernis" },
    { value: "decoration_interieure", label: "Décoration intérieure" },
    { value: "peinture_effet", label: "Peinture effet décoratif" },
    { value: "peinture_sol", label: "Peinture sol / résine" },
    { value: "renovation_cage_escalier", label: "Rénovation cage d'escalier" },
    { value: "peinture_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  plaquiste: [
    { value: "pose_placo", label: "Pose plaques de plâtre" },
    { value: "cloison_placo", label: "Création cloison placo" },
    { value: "doublage_murs", label: "Doublage murs" },
    { value: "faux_plafond_placo", label: "Faux plafond placo" },
    { value: "bandes_joints", label: "Bandes & joints" },
    { value: "isolation_murs", label: "Isolation murs intérieurs" },
    { value: "isolation_combles_amenages", label: "Isolation combles aménagés" },
    { value: "plaquiste_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  facade: [
    { value: "ravalement", label: "Ravalement façade" },
    { value: "nettoyage_facade_ext", label: "Nettoyage façade" },
    { value: "enduit_facade", label: "Enduit façade" },
    { value: "reprise_fissures_facade", label: "Reprise fissures façade" },
    { value: "peinture_facade", label: "Peinture façade" },
    { value: "hydrofuge_facade", label: "Traitement hydrofuge façade" },
    { value: "facade_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  menuiserie: [
    { value: "menuiserie_interieure", label: "Menuiserie intérieure" },
    { value: "pose_porte_interieure", label: "Pose porte intérieure" },
    { value: "pose_porte_entree", label: "Pose porte d'entrée" },
    { value: "pose_fenetre", label: "Pose fenêtre / double vitrage" },
    { value: "pose_volet", label: "Pose volet / volet roulant" },
    { value: "pose_store", label: "Pose store / banne" },
    { value: "pose_portail", label: "Pose portail" },
    { value: "pose_pergola", label: "Pose pergola" },
    { value: "pose_claustra", label: "Pose claustra" },
    { value: "reglage_menuiserie", label: "Réglage menuiserie" },
    { value: "charpente_toiture", label: "Charpente & Toiture" },
    { value: "pose_velux", label: "Pose Velux / fenêtre de toit" },
    { value: "zinguerie_gouttiere", label: "Zinguerie & Gouttière" },
    { value: "isolation_doublage", label: "Isolation & Doublage" },
    { value: "isolation_combles", label: "Isolation combles" },
    { value: "parquet_stratifie", label: "Parquet & Stratifié" },
    { value: "pose_parquet_massif", label: "Pose parquet massif" },
    { value: "pose_stratifie", label: "Pose stratifié / vinyle" },
    { value: "pose_plinthes", label: "Pose plinthes" },
    { value: "escaliers_garde_corps", label: "Escaliers & Garde-corps" },
    { value: "agencement_placard", label: "Agencement placards / dressing" },
    { value: "pose_dressing", label: "Pose dressing" },
    { value: "terrasse_bois", label: "Terrasse bois" },
    { value: "bardage_bois", label: "Bardage bois extérieur" },
    { value: "menuiserie_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  couverture: [
    { value: "reparation_toiture", label: "Réparation toiture" },
    { value: "recherche_fuite_toiture", label: "Recherche fuite toiture" },
    { value: "remplacement_tuiles", label: "Remplacement tuiles / ardoises" },
    { value: "pose_gouttieres", label: "Pose gouttières" },
    { value: "zinguerie", label: "Travaux de zinguerie" },
    { value: "demoussage_toiture", label: "Démoussage toiture" },
    { value: "etancheite_toiture", label: "Étanchéité toiture" },
    { value: "pose_fenetre_toit", label: "Pose fenêtre de toit / Velux" },
    { value: "couverture_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  serrurerie: [
    { value: "ouverture_porte", label: "Ouverture de porte" },
    { value: "remplacement_serrure", label: "Remplacement serrure" },
    { value: "blindage_porte", label: "Blindage porte" },
    { value: "pose_verrou", label: "Pose verrou / cylindre" },
    { value: "rideau_metallique", label: "Rideau métallique" },
    { value: "garde_corps_metal", label: "Garde-corps métallique" },
    { value: "portail_metal", label: "Portail / portillon métal" },
    { value: "serrurerie_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  vitrerie: [
    { value: "remplacement_vitre", label: "Remplacement vitre" },
    { value: "pose_vitrine", label: "Pose vitrine" },
    { value: "miroir_sur_mesure", label: "Miroir sur mesure" },
    { value: "reparation_vitrage", label: "Réparation vitrage" },
    { value: "double_vitrage", label: "Pose double vitrage" },
    { value: "vitrerie_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  cuisine_sdb: [
    { value: "pose_cuisine_comp", label: "Pose cuisine" },
    { value: "renovation_cuisine", label: "Rénovation cuisine" },
    { value: "pose_meuble_sdb", label: "Pose meuble salle de bain" },
    { value: "renovation_sdb", label: "Rénovation salle de bain" },
    { value: "pose_paroi_douche", label: "Pose paroi de douche" },
    { value: "pose_plan_travail", label: "Pose plan de travail" },
    { value: "cuisine_sdb_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  terrassement: [
    { value: "terrassement_gen", label: "Terrassement" },
    { value: "tranchee_reseaux", label: "Tranchée réseaux" },
    { value: "nivellement", label: "Nivellement terrain" },
    { value: "evacuation_terres", label: "Évacuation terres / gravats" },
    { value: "empierrement", label: "Empierrement" },
    { value: "creation_acces", label: "Création accès / allée" },
    { value: "terrassement_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  jardinage: [
    { value: "tonte_entretien_pelouse", label: "Tonte & Entretien pelouse" },
    { value: "taille_haies_arbustes", label: "Taille haies & arbustes" },
    { value: "elagage_abattage", label: "Élagage & Abattage arbres" },
    { value: "rognage_souche", label: "Rognage souche" },
    { value: "broyage_dechets_verts", label: "Broyage déchets verts" },
    { value: "nettoyage_debroussaillage", label: "Nettoyage & Débroussaillage" },
    { value: "ramassage_feuilles", label: "Ramassage feuilles mortes" },
    { value: "scarification", label: "Scarification pelouse" },
    { value: "plantation_engazonnement", label: "Plantation & Engazonnement" },
    { value: "engazonnement", label: "Engazonnement / semis pelouse" },
    { value: "paillage", label: "Paillage" },
    { value: "entretien_massifs", label: "Entretien massifs / plates-bandes" },
    { value: "pose_bordures", label: "Pose bordures" },
    { value: "creation_jardin", label: "Création jardin & Aménagement" },
    { value: "pose_gazon_synthetique", label: "Pose gazon synthétique" },
    { value: "arrosage_automatique", label: "Arrosage automatique" },
    { value: "traitement_desherbage", label: "Traitement & Désherbage" },
    { value: "remise_etat_jardin", label: "Remise en état jardin" },
    { value: "contrat_entretien", label: "Contrat entretien régulier" },
    { value: "evacuation_dechets_verts", label: "Évacuation déchets verts" },
    { value: "jardinage_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  nettoyage: [
    { value: "menage_domicile", label: "Ménage domicile" },
    { value: "entretien_bureaux", label: "Entretien bureaux / locaux" },
    { value: "entretien_copropriete", label: "Entretien copropriété" },
    { value: "nettoyage_apres_travaux", label: "Nettoyage après travaux" },
    { value: "nettoyage_fin_chantier_net", label: "Nettoyage fin de chantier" },
    { value: "remise_etat_logement", label: "Remise en état logement" },
    { value: "nettoyage_vitres", label: "Nettoyage de vitres" },
    { value: "nettoyage_haute_pression", label: "Nettoyage haute pression" },
    { value: "nettoyage_facade_net", label: "Nettoyage façade" },
    { value: "nettoyage_toiture_net", label: "Nettoyage / démoussage toiture" },
    { value: "nettoyage_terrasse", label: "Nettoyage terrasse" },
    { value: "demoussage_dallage", label: "Démoussage dallage" },
    { value: "nettoyage_gouttiere", label: "Nettoyage gouttières" },
    { value: "nettoyage_parking", label: "Nettoyage parking / sol extérieur" },
    { value: "nettoyage_panneaux_solaires", label: "Nettoyage panneaux solaires" },
    { value: "nettoyage_industriel", label: "Nettoyage industriel" },
    { value: "desinfection_assainissement", label: "Désinfection & Assainissement" },
    { value: "debarras_encombrants", label: "Débarras & Évacuation encombrants" },
    { value: "sortie_conteneurs", label: "Sortie conteneurs / poubelles" },
    { value: "nettoyage_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  aide_personne: [
    { value: "garde_enfants", label: "Garde d'enfants à domicile" },
    { value: "baby_sitting", label: "Baby-sitting ponctuel" },
    { value: "aide_devoirs", label: "Aide aux devoirs" },
    { value: "accompagnement_personnes_agees", label: "Accompagnement personnes âgées" },
    { value: "aide_domicile", label: "Aide à domicile" },
    { value: "aide_courses", label: "Aide aux courses & Livraison" },
    { value: "aide_repas", label: "Préparation repas à domicile" },
    { value: "aide_toilette", label: "Aide à la toilette" },
    { value: "aide_administrative", label: "Aide administrative" },
    { value: "aide_personne_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  animaux: [
    { value: "garde_chien_chat", label: "Garde chien / chat à domicile" },
    { value: "promenade_chiens", label: "Promenade chiens" },
    { value: "pet_sitting", label: "Pet-sitting" },
    { value: "toilettage", label: "Toilettage" },
    { value: "transport_veterinaire", label: "Transport vétérinaire" },
    { value: "soins_animaux", label: "Soins animaux" },
    { value: "animaux_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  informatique: [
    { value: "installation_pc", label: "Installation & Configuration PC" },
    { value: "depannage_informatique", label: "Dépannage informatique" },
    { value: "maintenance_informatique", label: "Maintenance informatique" },
    { value: "reseau_wifi", label: "Réseau & WiFi" },
    { value: "installation_tv", label: "Installation TV & Home cinéma" },
    { value: "installation_camera", label: "Installation caméra / surveillance" },
    { value: "installation_fibre_info", label: "Installation box / fibre" },
    { value: "installation_imprimante", label: "Installation imprimante" },
    { value: "recuperation_donnees", label: "Récupération données" },
    { value: "sauvegarde_donnees", label: "Sauvegarde données" },
    { value: "formation_informatique", label: "Formation informatique" },
    { value: "informatique_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  demenagement: [
    { value: "demenagement", label: "Déménagement" },
    { value: "transport_meubles", label: "Transport de meubles" },
    { value: "montage_demontage", label: "Montage & Démontage meubles" },
    { value: "mise_en_cartons", label: "Mise en cartons" },
    { value: "portage_etages", label: "Portage en étages" },
    { value: "livraison", label: "Livraison" },
    { value: "livraison_montage", label: "Livraison & montage" },
    { value: "debarras", label: "Débarras" },
    { value: "demenagement_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  administratif: [
    { value: "secretariat_saisie", label: "Secrétariat & Saisie" },
    { value: "comptabilite_declarations", label: "Comptabilité & Déclarations" },
    { value: "cours_particuliers", label: "Cours particuliers" },
    { value: "coaching_accompagnement", label: "Coaching & Accompagnement" },
    { value: "administratif_autre", label: "Autre (saisie libre)", isCustom: true }
  ],
  autre: [
    { value: "autre_libre", label: "Autre (saisie libre)", isCustom: true }
  ]
};

// Get domain label
export const getDomainLabel = (domainValue) => {
  if (!domainValue) return '';
  const domain = DOMAINS.find(d => d.value === domainValue);
  if (domain) return domain.label;
  if (domainValue.startsWith('custom_')) {
    return domainValue.replace('custom_', '').replace(/_/g, ' ');
  }
  return domainValue;
};

// Get prestation label
export const getPrestationLabel = (prestationValue, domainValue) => {
  if (!prestationValue) return '';
  const prestations = PRESTATIONS[domainValue] || [];
  const prestation = prestations.find(p => p.value === prestationValue);
  if (prestation) return prestation.label;
  for (const domain of Object.keys(PRESTATIONS)) {
    const found = PRESTATIONS[domain].find(p => p.value === prestationValue);
    if (found) return found.label;
  }
  if (prestationValue.startsWith('custom_')) {
    return prestationValue.replace('custom_', '').replace(/_/g, ' ');
  }
  return prestationValue;
};

// Get prestations for a domain
export const getPrestationsForDomain = (domainValue) => {
  return PRESTATIONS[domainValue] || PRESTATIONS.autre;
};

// Check if value is custom
export const isCustomValue = (value, list) => {
  if (!value || !list) return false;
  const item = list.find(i => i.value === value);
  return item?.isCustom || false;
};

// Unit options
export const UNIT_OPTIONS = [
  { value: "hour", label: "Heure" },
  { value: "unit", label: "Unité" },
  { value: "intervention", label: "Intervention" },
  { value: "m2", label: "M²" },
  { value: "m3", label: "M³" },
  { value: "ml", label: "Ml (mètre linéaire)" },
  { value: "forfait", label: "Forfait" },
  { value: "day", label: "Jour" },
  { value: "week", label: "Semaine" },
  { value: "kg", label: "Kg" },
  { value: "tonne", label: "Tonne" },
  { value: "custom", label: "Autre (saisie libre)", isCustom: true }
];

// Get unit label
export const getUnitLabel = (value) => {
  if (!value) return '';
  const unit = UNIT_OPTIONS.find(u => u.value === value);
  if (unit) return unit.label;
  if (value.startsWith('custom_')) {
    return value.replace('custom_', '');
  }
  return value;
};

// TVA rates for France
export const TVA_RATES = [
  { value: 0, label: "0% (Exonéré)" },
  { value: 5.5, label: "5,5% (Taux réduit)" },
  { value: 10, label: "10% (Taux intermédiaire)" },
  { value: 20, label: "20% (Taux normal)" }
];

export const buildServiceDescription = (domain, prestation, customDomain, customPrestation) => {
  const domainLabel = customDomain || getDomainLabel(domain);
  const prestationLabel = customPrestation || getPrestationLabel(prestation, domain);
  return `${prestationLabel} - ${domainLabel}`;
};

export const getCategoryLabel = (category) => {
  if (!category) return '';
  for (const domain of Object.keys(PRESTATIONS)) {
    const found = PRESTATIONS[domain].find(p => p.value === category);
    if (found) return found.label;
  }
  const domain = DOMAINS.find(d => d.value === category);
  if (domain) return domain.label;
  if (category.startsWith('custom_')) {
    return category.replace('custom_', '').replace(/_/g, ' ');
  }
  const legacyMap = {
    'main_oeuvre': "Main d'œuvre",
    'materiaux': 'Matériaux',
    'deplacement': 'Déplacement',
    'autre': 'Autre'
  };
  return legacyMap[category] || category;
};

export const getCategoryGroup = (category) => {
  if (!category) return 'AUTRE';
  for (const [domainKey, prestations] of Object.entries(PRESTATIONS)) {
    if (prestations.find(p => p.value === category)) {
      const domain = DOMAINS.find(d => d.value === domainKey);
      return domain?.label?.toUpperCase() || domainKey.toUpperCase();
    }
  }
  const legacyGroups = {
    'main_oeuvre': 'COMMUN À TOUS LES MÉTIERS',
    'materiaux': 'COMMUN À TOUS LES MÉTIERS',
    'deplacement': 'COMMUN À TOUS LES MÉTIERS',
    'autre': 'AUTRE'
  };
  return legacyGroups[category] || 'AUTRE';
};
